export default __webpack_public_path__ + "images/chart-line-green.94a572bf04a88c45688a7101e1e1596d.png";